import { Injectable } from 'injection-js';
import { Element } from 'shared/core';
@Injectable()
export class DownloadElement extends Element {
  constructor() {
    super();
  }

  public init(): void {
    $(document).ready(function() {
      const url_params = new URLSearchParams(window.location.search);
      const download_url = url_params.get('download_url');

      if (download_url) {
        // Trigger the download
        window.location.href = download_url;
      }

      const url = new URL(window.location.href);
      url.searchParams.delete('download_url');
      window.history.replaceState({}, '', url.toString());
    });
  }
}
